import { a } from "../../../chunk-OA3DH5LS-40f95340.js";
const o = a("Pagination").parts("container");
export {
  o as PaginationAnatomy
};
//# sourceMappingURL=Pagination.anatomy.es.js.map
